import React from 'react'

function SongCover() {
  
  return (
    <img id={`song-cover`} alt="cover" loading="lazy" />
  )
}

export default SongCover